(function () {
  'use strict';

  var routes = (window.Shopify && window.Shopify.routes) || {};

  function cartUrl(key) {
    if (routes[key]) return routes[key];
    var root = routes.root || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    var paths = {
      cartAdd: 'cart/add.js',
      cartGet: 'cart.js',
      cartChange: 'cart/change.js',
    };
    return root + (paths[key] || '');
  }

  /* ─── Smooth scroll-linked hero / header ─── */
  var header = document.querySelector('[data-site-header]');
  var heroLogo = document.querySelector('[data-hero-logo]');
  var headerLogo = document.querySelector('[data-header-logo]');
  var headerLogoText = headerLogo ? headerLogo.querySelector('.site-header__logo-text') : null;
  var hasHero = document.querySelector('[data-hero]');
  var root = document.documentElement;
  var scrollTicking = false;

  if (hasHero && heroLogo && headerLogoText) {
    var heroLogoText = heroLogo.querySelector('.hero__logo-text');
    if (heroLogoText) headerLogoText.textContent = heroLogoText.textContent.trim();
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function updateHeaderSmooth() {
    scrollTicking = false;
    if (!header) return;

    var scrollY = window.scrollY;
    var threshold = hasHero ? window.innerHeight * 0.55 : 80;
    var progress = Math.min(Math.max(scrollY / threshold, 0), 1);
    var eased = easeOutCubic(progress);

    root.style.setProperty('--hero-scroll', progress);
    root.style.setProperty('--hero-logo-opacity', hasHero ? Math.max(0, 1 - Math.max(progress - 0.9, 0) / 0.1) : 0);
    root.style.setProperty('--hero-logo-scale', 1 - eased * 0.84);
    root.style.setProperty('--header-logo-opacity', hasHero ? Math.max(0, (progress - 0.88) / 0.12) : eased);
    root.style.setProperty('--header-logo-scale', 0.88 + eased * 0.12);

    if (hasHero) {
      if (heroLogo && headerLogo) {
        var heroRect = hasHero.getBoundingClientRect();
        var headerRect = headerLogo.getBoundingClientRect();
        var sourceX = heroRect.left + heroRect.width / 2;
        var sourceY = heroRect.top + heroRect.height / 2;
        var targetX = headerRect.left + headerRect.width / 2;
        var targetY = headerRect.top + headerRect.height / 2;
        root.style.setProperty('--hero-logo-x', (targetX - sourceX) * eased + 'px');
        root.style.setProperty('--hero-logo-y', (targetY - sourceY) * eased + 'px');
      }
      var solid = progress > 0.72;
      header.classList.toggle('site-header--transparent', !solid);
      header.classList.toggle('site-header--solid', solid);
      if (headerLogo) headerLogo.classList.toggle('is-visible', progress > 0.9);
    } else {
      header.classList.add('site-header--solid');
      root.style.setProperty('--hero-logo-x', '0px');
      root.style.setProperty('--hero-logo-y', '0px');
      root.style.setProperty('--header-logo-opacity', 1);
      root.style.setProperty('--header-logo-scale', 1);
      if (headerLogo) headerLogo.classList.add('is-visible');
    }
  }

  function onScroll() {
    if (!scrollTicking) {
      scrollTicking = true;
      requestAnimationFrame(updateHeaderSmooth);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateHeaderSmooth, { passive: true });
  updateHeaderSmooth();

  /* ─── Reveal on scroll ─── */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    document.querySelectorAll('.reveal').forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ─── Mobile menu ─── */
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var menuToggle = document.querySelector('[data-menu-open]');

  function openMobileMenu() {
    if (!mobileMenu || !header) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    header.classList.add('is-menu-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileMenu || !header) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    header.classList.remove('is-menu-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      if (mobileMenu && mobileMenu.classList.contains('is-open')) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });
  }

  document.querySelectorAll('[data-menu-close]').forEach(function (el) {
    el.addEventListener('click', closeMobileMenu);
  });

  document.querySelectorAll('[data-menu-close-link]').forEach(function (el) {
    el.addEventListener('click', closeMobileMenu);
  });

  /* ─── Accordions ─── */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var accordion = trigger.closest('[data-accordion]');
      var isOpen = accordion.classList.contains('is-open');
      accordion.closest('.product-page__accordions')
        ?.querySelectorAll('[data-accordion]').forEach(function (a) {
          a.classList.remove('is-open');
        });
      if (!isOpen) accordion.classList.add('is-open');
    });
  });

  /* ─── Size selector & add to cart ─── */
  document.querySelectorAll('.product-form').forEach(function (form) {
    var sizeButtons = form.querySelectorAll('[data-size-option]');
    var variantInput = form.querySelector('[name="id"]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var priceDisplay = form.querySelector('[data-add-to-cart-price]');

    if (!variantInput) return;

    var variants = [];
    try {
      variants = JSON.parse(form.dataset.variants || '[]');
    } catch (e) {}

    function selectSize(btn) {
      sizeButtons.forEach(function (b) {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');

      var variantId = btn.dataset.variantId;
      if (variantId) {
        variantInput.value = variantId;
        var variant = variants.find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (variant && addBtn) {
          addBtn.disabled = !variant.available;
          if (priceDisplay && variant.price) {
            priceDisplay.textContent = variant.formatted_price;
          }
        }
      }
    }

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-unavailable')) return;
        selectSize(btn);
      });
    });

    var firstAvailable = form.querySelector('[data-size-option]:not(.is-unavailable)');
    if (firstAvailable) selectSize(firstAvailable);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn && addBtn.disabled) return;

      var variantId = parseInt(variantInput.value, 10);
      if (!variantId) return;

      var originalHtml = addBtn.innerHTML;
      addBtn.disabled = true;
      addBtn.textContent = 'ADDING…';

      fetch(cartUrl('cartAdd'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              var msg = (data && data.description) || (data && data.message) || 'Add to cart failed';
              throw new Error(msg);
            }
            return data;
          });
        })
        .then(function () {
          return refreshCart();
        })
        .then(function () {
          openCartDrawer();
        })
        .catch(function (err) {
          alert(err.message || 'Could not add item to cart. Please try again.');
        })
        .finally(function () {
          addBtn.disabled = false;
          addBtn.innerHTML = originalHtml;
        });
    });
  });

  /* ─── Lookbook marquee pause ─── */
  document.querySelectorAll('[data-lookbook-marquee]').forEach(function (marquee) {
    var section = marquee.closest('[data-lookbook-section]');
    if (!section || section.dataset.pauseOnHover === 'false') return;

    marquee.addEventListener('mouseenter', function () {
      marquee.classList.add('is-paused');
    });
    marquee.addEventListener('mouseleave', function () {
      marquee.classList.remove('is-paused');
    });
    marquee.addEventListener('touchstart', function () {
      marquee.classList.add('is-paused');
    }, { passive: true });
    marquee.addEventListener('touchend', function () {
      setTimeout(function () {
        marquee.classList.remove('is-paused');
      }, 2000);
    }, { passive: true });
  });

  /* ─── Product gallery mobile label ─── */
  document.querySelectorAll('.product-page__gallery').forEach(function (gallery) {
    if (window.matchMedia('(max-width: 1024px)').matches && gallery.children.length > 1) {
      gallery.setAttribute('tabindex', '0');
      gallery.setAttribute('aria-label', 'Product images, scroll to browse');
    }
  });

  /* ─── Pinned product image stack ─── */
  document.querySelectorAll('[data-product-scroll-stage]').forEach(function (stage) {
    var windowEl = stage.querySelector('[data-product-gallery-window]');
    var track = stage.querySelector('[data-product-gallery-track]');
    if (!windowEl || !track) return;

    var mediaQuery = window.matchMedia('(min-width: 1025px)');
    var ticking = false;
    var maxTravel = 0;
    var stageStart = 0;

    function measureProductScroll() {
      if (!mediaQuery.matches) {
        stage.style.minHeight = '';
        stage.style.setProperty('--product-gallery-y', '0px');
        stage.classList.remove('is-product-pinned', 'is-product-released');
        return;
      }

      stage.classList.remove('is-product-pinned', 'is-product-released');
      stage.style.minHeight = '';
      stage.style.setProperty('--product-gallery-y', '0px');
      maxTravel = Math.max(0, track.scrollHeight - windowEl.clientHeight);
      stage.style.minHeight = windowEl.clientHeight + maxTravel + 'px';
      stageStart = stage.getBoundingClientRect().top + window.scrollY;
      updateProductScroll();
    }

    function updateProductScroll() {
      ticking = false;
      if (!mediaQuery.matches) return;

      var scrollDistance = Math.max(1, maxTravel);
      var localScroll = window.scrollY - stageStart;
      var progress = Math.min(Math.max(localScroll / scrollDistance, 0), 1);
      stage.classList.toggle('is-product-pinned', localScroll >= 0 && progress < 1);
      stage.classList.toggle('is-product-released', progress >= 1);
      stage.style.setProperty('--product-gallery-y', -maxTravel * progress + 'px');
    }

    function requestProductScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateProductScroll);
      }
    }

    measureProductScroll();
    window.addEventListener('scroll', requestProductScroll, { passive: true });
    window.addEventListener('resize', measureProductScroll, { passive: true });
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', measureProductScroll);
    }
    window.addEventListener('load', measureProductScroll, { once: true });
  });

  /* ─── Cart drawer ─── */
  var overlay = document.querySelector('[data-cart-overlay]');
  var drawer = document.querySelector('[data-cart-drawer]');
  var cartContent = document.querySelector('[data-cart-content]');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function openCartDrawer() {
    closeMobileMenu();
    if (overlay) overlay.classList.add('is-open');
    if (drawer) drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (overlay) overlay.classList.remove('is-open');
    if (drawer) drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCart().then(openCartDrawer);
    });
  });

  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeCartDrawer);
  });

  if (overlay) {
    overlay.addEventListener('click', closeCartDrawer);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeMobileMenu();
    }
  });

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCart() {
    return fetch(cartUrl('cartGet'), {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart fetch failed');
        return res.json();
      })
      .then(function (cart) {
        cartCountEls.forEach(function (el) {
          el.textContent = cart.item_count;
        });
        renderCart(cart);
        return cart;
      });
  }

  function renderCart(cart) {
    if (!cartContent) return;

    if (cart.item_count === 0) {
      cartContent.innerHTML =
        '<p class="cart-drawer__empty">Your cart is empty</p>';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      html +=
        '<div class="cart-item" data-line-key="' +
        item.key +
        '">' +
        '<div class="cart-item__image">' +
        (item.image
          ? '<img src="' +
            item.image +
            '" alt="' +
            item.title +
            '" width="80" height="107" loading="lazy">'
          : '') +
        '</div>' +
        '<div class="cart-item__details">' +
        '<p class="cart-item__title">' +
        item.product_title +
        '</p>' +
        (item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="cart-item__variant">' + item.variant_title + '</p>'
          : '') +
        '<p class="cart-item__price">' +
        formatMoney(item.final_line_price) +
        '</p>' +
        '<button type="button" class="cart-item__remove" data-remove-item="' +
        item.key +
        '">Remove</button>' +
        '</div>' +
        '<div class="cart-item__qty">' +
        '<button type="button" data-qty-change="' +
        item.key +
        '" data-qty="' +
        (item.quantity + 1) +
        '">+</button>' +
        '<span>' +
        item.quantity +
        '</span>' +
        '<button type="button" data-qty-change="' +
        item.key +
        '" data-qty="' +
        (item.quantity - 1) +
        '">−</button>' +
        '</div>' +
        '</div>';
    });

    cartContent.innerHTML = html;

    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    bindCartEvents();
  }

  function bindCartEvents() {
    document.querySelectorAll('[data-remove-item]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateLine(btn.dataset.removeItem, 0);
      });
    });

    document.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateLine(btn.dataset.qtyChange, parseInt(btn.dataset.qty, 10));
      });
    });
  }

  function updateLine(key, quantity) {
    fetch(cartUrl('cartChange'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        cartCountEls.forEach(function (el) {
          el.textContent = cart.item_count;
        });
        renderCart(cart);
      });
  }
})();
